import "./index.scss";
import { useState, useRef, useEffect } from "react";
import logo from "../../assets/images/icons/chat.svg";
import logoArrow from "../../assets/images/icons/arrow-up-blue.svg";

const AccordionModal = ({
  title,
  children,
  bgColor = "#e4f998",
  marginBottom = "32px",
  canClose = true,
}) => {
  const [isOpen, setIsOpen] = useState(!canClose);
  const panelRef = useRef(null);

  const toggleAccordion = () => {
    setIsOpen((prev) => !prev);
  };

  useEffect(() => {
    const panel = panelRef.current;

    const adjustHeight = () => {
      if (panel) {
        if (isOpen) {
          panel.style.maxHeight = `${panel.scrollHeight + 16}px`;
        } else {
          panel.style.maxHeight = "0px";
        }
      }
    };

    adjustHeight();

    window.addEventListener("resize", adjustHeight);

    return () => {
      window.removeEventListener("resize", adjustHeight);
    };
  }, [isOpen]);

  return (
    <div
      className="accordion-modal-container"
      style={{
        borderRadius: "4px",
        marginBottom: marginBottom,
        background: bgColor,
      }}
    >
      <button
        className={`header ${isOpen ? "active" : ""}`}
        style={{ cursor: !canClose ? "default" : "pointer" }}
        onClick={canClose ? toggleAccordion : () => setIsOpen(true)}
      >
        <span className="header-content">
          <div className="header-content-left">
            <img src={logo} alt="ícone de balão" />
            <p>{title}</p>
          </div>
          {canClose ? (
            <img
              src={logoArrow}
              className={`${isOpen ? "rotate-up" : "rotate-down"}`}
              alt="ícone de seta"
            />
          ) : (
            ""
          )}
        </span>
      </button>

      <div className="panel" ref={panelRef}>
        {children}
      </div>
    </div>
  );
};

export default AccordionModal;
